export const GRAY_2 = '#151b26';
export const GRAY_4 = '#5c5f66';
export const GRAY_5 = '#84868c';
export const GRAY_6 = '#b8babf';
export const GRAY_8 = '#e8e9eb';
export const GRAY_10 = '#f7f7f9';
export const GRAY_11 = '#ffffff';

export const RED = '#f33d3d';

export const COLOR_BRAND_6 = '#2468F2';
